import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DTFEditor } from './editors';

class App extends React.Component {
	render() {
		return (
			<div className="rde-main">
				<Helmet>
					<meta charSet="utf-8" />
					<meta name="viewport" content="width=device-width, initial-scale=1.0" />
					<meta
						name="description"
						content="Éditeur DTF — composez votre planche de transferts DTF : importez vos logos, choisissez la taille et la quantité, le placement et le prix sont automatiques."
					/>
					<link rel="manifest" href="./manifest.json" />
					<link rel="shortcut icon" href="./favicon.ico" />
					<title>Éditeur DTF</title>
				</Helmet>
				<DTFEditor />
			</div>
		);
	}
}

export default App;
